/* eslint-disable @typescript-eslint/no-explicit-any */
import { atom } from 'jotai';
import { TemplateServices } from 'src/libs/services/template.service';

export const favoritesTemplateAtom = atom<any[]>([]);

export const getFavoritesTemplateAtom = atom(
  null,
  async (get, set) => {
    const response = await TemplateServices.getFavoriteTemplates();
    const data = response.data;
    set(favoritesTemplateAtom, data);
  }
);